import { Component, OnInit } from '@angular/core';
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";
import { TipoTransporteService } from "../laudos-cd/tipo-transporte.service";
import { TipoTransporteModel } from "../laudos-cd/tipo-transporte.model";

declare var swal: any;

@Component({
  selector: 'app-tipo-transporte',
  templateUrl: './tipo-transporte.component.html'
})
export class TipoTransporteComponent extends Components implements OnInit {

  tiposTransporte: TipoTransporteModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService,
    private tipoTransporteService: TipoTransporteService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].id_acao == '24'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.getPage(1);
  }

  getPage(page: number) {
    this.paginaAtual = page;
    this.carregandoTabela = true;
    this.tipoTransporteService.getPaginacao(page, this.itensPorPagina).subscribe(json => {
      this.tiposTransporte = json.Payload.data;
      this.totalItens = json.Payload.total;
      this.carregandoTabela = false;
    }, error => {
      this.func.showErro(error.json());
      this.carregandoTabela = false;
    });
  }

  delete(tipoTransporte: TipoTransporteModel) {
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarTipoTransporte') + tipoTransporte.nome_pt + '?',
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.tipoTransporteService.apagar(tipoTransporte.id).subscribe(data => {
          self.getPage(self.paginaAtual);
        }, error => {
          self.func.showErro(error.json());
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/tipo-transporte/tipo-transporte.component.ts